export const PAYMENT_DETAILS_SHARE_VIA_EMAIL_REQUEST = "PAYMENT_DETAILS_SHARE_VIA_EMAIL_REQUEST";
export const PAYMENT_DETAILS_SHARE_VIA_EMAIL_SUCCESS = "PAYMENT_DETAILS_SHARE_VIA_EMAIL_SUCCESS";
export const PAYMENT_DETAILS_SHARE_VIA_EMAIL_ERROR = "PAYMENT_DETAILS_SHARE_VIA_EMAIL_ERROR";
